module.exports = __webpack_public_path__ + "img/cp-map-area.ee2e33c1.svg";